import React, { useCallback, useMemo } from 'react'

import { AuthContext, AuthContextValue } from './AuthContext'

import {
  ACCESS_TOKEN_STORAGE_KEY,
  PATH,
  PROFILE_STORAGE_FIELDS,
} from '../../../constants'
import { useLogin } from '../../../hooks/useLogin'

type AuthProviderProps = {
  children: React.ReactNode
}

const LOGIN_URL = process.env.VITE_OPENID_CONNECT_URL

const useAuth = () =>
  useMemo(() => {
    const data: AuthContextValue = {
      token: '',
      name: '',
      kana: '',
      email: '',
      phone: '',
      postalCode: '',
      prefecture: '',
      address1: '',
      address2: '',
      address3: '',
      dateOfBirth: '',
    }
    try {
      data.token = sessionStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) || ''
      PROFILE_STORAGE_FIELDS.forEach((field) => {
        data[field] = sessionStorage.getItem(field) || ''
      })
    } catch (e) {
      // Do Nothing
    }

    return data
  }, [])

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { onLogin } = useLogin()
  const context = useAuth()
  const isRedirectToLoginPage = useCallback(() => {
    if (!LOGIN_URL) {
      return false
    }

    const loginModalPages = [
      PATH.reservations.hotels.root,
      PATH.reservations.spas.root,
      PATH.reservations.activities.root,
    ]
    if (loginModalPages.includes(window.location.pathname)) {
      return false
    }

    return !context.token
  }, [context.token])

  if (isRedirectToLoginPage()) {
    onLogin()
    return null
  }

  return <AuthContext.Provider value={context}>{children}</AuthContext.Provider>
}
